import React, { useEffect } from "react";
import Aos from "aos";
import { Routes, Route } from "react-router-dom";
import Homeone from "../components/Homeone/Main";
import BlogList from "../components/Pages/BlogList/Main";
import SingleBlog from "../components/Pages/SingleBlog/Main";
import Reviews from "../components/Reviews/Main";
import Jasa from "../components/Jasa/Main";
import ContactUs from "../components/ContactUs/Main";
import Pricing from "../components/Pricing/Main";
import LabelWoven from "../components/LabelWoven/Main";
import HangTag from "../components/HangTag/Main";
import SatinNylon from "../components/SatinNylon/Main";
import Katun from "../components/Katun/Main";
import Logo from "../components/Logo/Main";
import ScrollToTop from "../components/Global/ScrollToTop";

const Index = () => {
  useEffect(() => {
    Aos.init();
    Aos.refresh();
  }, []);
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homeone />} />
        <Route path="/blog-list" element={<BlogList />} />
        <Route path="/blog-detail" element={<SingleBlog />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/jasa" element={<Jasa />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/label-woven" element={<LabelWoven />} />
        <Route path="/hangtag" element={<HangTag />} />
        <Route path="/satin-nylon" element={<SatinNylon />} />
        <Route path="/katun" element={<Katun />} />
        <Route path="/logo" element={<Logo />} />
      </Routes>
    </>
  );
};

export default Index;
